<template>
</template>

<script>
  import { mapState } from 'vuex'
  import c3 from 'c3'
  import d3 from 'd3'
  import '@/assets/chart/c3.min.css'
  import * as func from '@/assets/chart/chartFunc'

  var chart2
  export default {
    name: 'vtrChart',
    props: {
      chartData: Array,
      chartName: String,
      vtrAvg: String
    },
    methods: {
      drawChart () {
        if (this.chartData === undefined || this.chartData.length === 0) return
        let tooltipFormat = d3.format(',r')

        let id = '#vtrChart'
        let data = this.chartData
        let axisInfo = func.getAxisRangeVtr(data)
        let y1Range = func.getYRange(axisInfo.y1Min, axisInfo.y1Max, true) // y axis의 range
        let y2Range = func.getYRange(axisInfo.y2Min, axisInfo.y2Max, false) // y axis의 range
        let avgVtr = this.vtrAvg
        let chartName = this.chartName
        d3.select('#chartContainer').append('div')
          .attr('id', 'vtrChartWrap')
        d3.select('#vtrChartWrap').append('div')
          .attr('class', 'chartTitle').text(chartName + ' - VTR')
        d3.select('#vtrChartWrap')
        .append('div').attr('id', 'vtrChart')

        chart2 = c3.generate({
          bindto: id,
          size: {
            height: 250
          },
          data: {
            json: data,
            keys: {
              value: ['view_cnt', 'vtr', 'end_rate']
            },
            types: {
              view_cnt: 'bar',
              vtr: 'spline',
              end_rate: 'spline'
            },
            axes: {
              view_cnt: 'y',
              vtr: 'y2',
              end_rate: 'y2'
            },
            names: {
              view_cnt: 'VIEW',
              vtr: 'VTR(%)',
              end_rate: '재생완료(%)'
            },
            color: function (color, d) {
              // d will be 'id' when called for legends //303f9f
              // url(#vgradient)

              if (d === 'vtr') {
                return '#ea5c58'
              } else if (d === 'end_rate') {
                return '#f9835e'
              }
              return (d.id === 'vtr') ? '#ea5c58'
              : (d.id === 'end_rate') ? '#f9835e' : '#4cdbec'
            }
          },
          bar: {
            width: {
              ratio: 0.5,
              max: 80 // max-width
            }
          },
          point: {
            r: 3,
            focus: {
              expand: {
                r: 4
              }
            }
          },
          axis: {
            x: {
              type: 'category',
              categories: axisInfo.xCategory,
              tick: {
                outer: false,
                centered: true,
                multiline: false,
                culling: {
                  max: data.length / 5 + 1 // 표시할 x axis수
                },
                format: function (x) { return func.parse(axisInfo.xCategory[x]) }
              }
            },
            y: {
              max: y1Range.max,
              min: y1Range.min,
              tick: {
                values: func.getY1Values(y1Range.min, y1Range.max, axisInfo.view),
                format: d3.format(',.2r'),
                outer: false
              },
              padding: {
                bottom: 0
              }
            },
            y2: {
              show: true,
              max: y2Range.max,
              min: y2Range.min,
              tick: {
                values: func.getY2Values(y2Range.min, y2Range.max, axisInfo.vtr),
                format: d3.format('.0f'),
                outer: false
              },
              padding: {
                bottom: 0
              }
            }
          },
          tooltip: {
            format: {
              value: function (value, ratio, id) {
                return id === 'view_cnt' ? tooltipFormat(value) : value.toFixed(1)
              }
            }
          },
          grid: {
            y: {
              show: true,
              lines: [
                {value: avgVtr, axis: 'y2', class: 'avgCtr', text: 'vtr 평균 : ' + avgVtr + '%'}
              ]
            }
          },
          legend: {
            show: false
          }
        })

        d3.select('#vtrChartWrap').insert('div', '#vtrChart')
        .attr('class', 'legend').append('div').attr('class', 'legend_box_wrap')
        .selectAll('div').data(['view_cnt', 'vtr', 'end_rate'])
        .enter().append('div')
        .attr('data-id', function (id) { return id })
        .attr('class', 'legend_box')
        .html(function (id) {
          return id === 'view_cnt'
          ? '<img src="static/img/imp.png" class="imp_img"/>VIEW'
          : id === 'vtr'
          ? '<img src="static/img/ctr.png" class="ctr_img"/>VTR (%)'
          : '<img src="static/img/end_rate.png" class="ctr_img"/>재생완료 (%)'
        })
        .each(function (id) {
          if (id !== 'end_rate') d3.select(this).style('border-right', '10px solid #ffffff')
          d3.select(this).style('font-weight', '500')
        })
        .on('mouseover', function (id) {
          chart2.focus(id)
        })
        .on('mouseout', function (id) {
          chart2.revert()
        })
        .on('click', function (id) {
          chart2.toggle(id)
        })
      }
    },
    computed: {
      ...mapState({
        campaignInfo: state => state.campaign.campaignInfo
      })
    },
    mounted () {
      if (chart2 === undefined) this.drawChart()
    },
    watch: {
      chartData (val) {
        if (chart2 === undefined) {
          this.drawChart()
          return
        }
        let p = document.getElementById('chartContainer')
        let c = document.getElementById('vtrChartWrap')
        chart2.destroy()
        if (c) p.removeChild(c)
        this.drawChart()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VtrChart.vue?993cff7e